<template>
  <el-button-group>
    <el-button
      v-for="item in buttonList"
      :key="item.id"
      :type="item.type"
      :size="item.size"
      :icon="item.icon"
      @click="click(item.event)"
    >
      {{ item.name }}
    </el-button>
  </el-button-group>
</template>

<script>
export default {
  computed: {
    buttonList() {
      const getPermissionButton = (fullPath, adminMenus, initData) => {
        adminMenus.forEach((element) => {
          if (element != null && element.menuPath == fullPath) {
            // 获取菜单的按钮
            if (element.children != null && element.children.length > 0) {
              element.children.forEach((item) => {
                if (item.menuType == "3") {
                  let data = {
                    id: item.id,
                    name: item.menuName,
                    type: "primary",
                    size: "small",
                    icon: item.menuIcon,
                    event: item.menuRoute,
                  };
                  initData.push(data);
                }
              });
            }
          } else {
            if (element.children != null && element.children.length > 0) {
              getPermissionButton(fullPath, element.children, initData);
            }
          }
        });
      };

      let initData = [];
      let fullPath = this.$route.fullPath;
      let adminMenus = this.$store.state.adminMenus;
      if (adminMenus != null && adminMenus.length > 0) {
        getPermissionButton(fullPath, adminMenus, initData);
      }
      return initData;
    },
  },
  methods: {
    click(data) {
      console.log("data-name", data);
      this.$emit(data, {});
    },
  },
};
</script>